module.exports = {
  domain: {
    desktop: "ia.int.use2.racing.fndlext.net",
    mobile: "ia.int.use2.racing.fndlext.net",
    talentPicks: "ia.int.use2.racing.fndlext.net/talent-picks/",
    equibase: "equibase-store-qa.tvg.com"
  },
  recaptchaID: "6Lf-4hUqAAAAAGupa6W70kpZVsaFd7yaxz5pHD8r",
  recaptchaIdNative: "6Le9B1YqAAAAAJEWJZsQittPtHDcjz6xLNORgHyI"
};
